import { Tag } from 'liquidjs';

import type { LiquidSwell } from '..';
import type {
  Liquid,
  TagToken,
  Context,
  Parser,
  TopLevelToken,
  Emitter,
} from 'liquidjs';
import type { QuotedToken } from 'liquidjs/dist/tokens';
import type { TagClass, TagRenderReturn } from 'liquidjs/dist/template';
import type { SwellThemeConfig } from '../../../types/swell';

// {% section 'name' %}

export default function bind(liquidSwell: LiquidSwell): TagClass {
  return class SectionTag extends Tag {
    private fileName: string;

    constructor(
      token: TagToken,
      remainTokens: TopLevelToken[],
      liquid: Liquid,
      _parser: Parser,
    ) {
      super(token, remainTokens, liquid);
      const { tokenizer } = token;
      this.fileName = (tokenizer.readValue() as QuotedToken)?.content;
    }

    *render(_ctx: Context, emitter: Emitter): TagRenderReturn {
      const filePath = (yield liquidSwell.getSectionPath(
        this.fileName,
      )) as string;

      const themeConfig = (yield liquidSwell.getThemeConfig(
        filePath,
      )) as SwellThemeConfig | null;

      if (!themeConfig) {
        console.error(`Section not found: ${filePath}`);
        return;
      }

      let schema: any;
      let settings: any;

      const output = (yield liquidSwell.theme
        .getTemplateSchema(themeConfig)
        .then((sectionSchema) => {
          if (!sectionSchema) {
            console.error(`Section schema not found: ${filePath}`);
            return '';
          }

          schema = sectionSchema;

          const defaultSettings =
            liquidSwell.theme.resolveStaticSectionSettings(sectionSchema);

          settings = defaultSettings;

          return liquidSwell.renderTemplate(themeConfig, {
            section: {
              id: this.fileName,
              settings: { ...defaultSettings, blocks: undefined },
              blocks: defaultSettings.blocks,
            },
          });
        })) as string;

      if (output) {
        const { shopify_compatibility: shopifyCompatibility } =
          liquidSwell.theme.globals;

        const tag = schema.tag || 'div';

        const id = `${shopifyCompatibility ? 'shopify' : 'swell'}-section-${settings.id || this.fileName}`;

        const className = shopifyCompatibility
          ? 'shopify-section'
          : 'swell-section';

        emitter.write(
          `<${tag} id="${id}" class="${className} ${schema.class || ''}">${output}</${tag}>`,
        );
      }
    }
  };
}
